import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";

export default function VacationMy() {
  const { fetchMyVacations, requestVacation, acceptVacation, deleteVacation, user } = useAuth();
  const [vacations, setVacations] = useState([]);
  const [form, setForm] = useState({ startDate: "", endDate: "", comment: "" });

  const load = async () => {
    const v = await fetchMyVacations();
    setVacations(v);
  };

  useEffect(() => { load(); }, []);

  const handleSubmit = async () => {
    if (!form.startDate || !form.endDate) return;
    await requestVacation(form);
    setForm({ startDate: "", endDate: "", comment: "" });
    load();
  };

  const handleAccept = async (id) => {
    await acceptVacation(id);
    load();
  };

  return (
    <div className="container mt-5">
      <h3 className="mb-4">Mina semesterförfrågningar</h3>

      <div className="card mb-4">
        <div className="card-body">
          <h5 className="card-title">Ny förfrågan</h5>
          <div className="row g-2">
            <div className="col-md-3">
              <label className="form-label">Start</label>
              <input type="date" className="form-control" placeholder="yyyy-mm-dd"
                value={form.startDate}
                onChange={(e) => setForm({ ...form, startDate: e.target.value })} />
            </div>
            <div className="col-md-3">
              <label className="form-label">Slut</label>
              <input type="date" className="form-control"
                value={form.endDate}
                onChange={(e) => setForm({ ...form, endDate: e.target.value })} />
            </div>
            <div className="col-md-4">
              <label className="form-label">Kommentar</label>
              <input type="text" className="form-control"
                placeholder="Kommentar"
                value={form.comment}
                onChange={(e) => setForm({ ...form, comment: e.target.value })} />
            </div>
            <div className="col-md-2">
              <button className="btn btn-primary w-100" onClick={handleSubmit}>Skicka</button>
            </div>
          </div>
        </div>
      </div>

      {vacations.map(v => (
        <div key={v._id} className="card mb-2">
          <div className="card-body">
            <strong>{new Date(v.startDate).toLocaleDateString("sv-SE")} – {new Date(v.endDate).toLocaleDateString("sv-SE")}</strong>
            <div>Status: <span className="badge bg-secondary">{v.status}</span></div>
            {v.comment && <div>Min kommentar: {v.comment}</div>}
            {v.status === "Ändringsförslag" && (
              <div className="mt-2">
                <div>Admin föreslog: {new Date(v.suggestedStart).toLocaleDateString("sv-SE")} – {new Date(v.suggestedEnd).toLocaleDateString("sv-SE")}</div>
                {v.adminComment && <div>Kommentar: {v.adminComment}</div>}
                <button className="btn btn-success btn-sm mt-2 me-2" onClick={() => handleAccept(v._id)}>Acceptera förslaget</button>
                <button
                  className="btn btn-outline-danger btn-sm mt-2"
                  onClick={() => {
                    if (window.confirm("Om du tar bort denna måste du söka på nytt. Är du säker?")) {
                      deleteVacation(v._id).then(load);
                    }
                  }}
                >
                  Ta bort ansökan
                </button>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
